export default "__VITE_ASSET__DUJkT5Hf__"